import React, { Component } from "react";
import TitleWithControl from "../../ComponentsPedidos/TitleWithControl";
import ButtonContinue from "../../ComponentsPedidos/ButtonContinue";
import ButtonEdit from "../../ComponentsPedidos/ButtonEdit";
import Modal, { ModalParceiro } from "../../Modals";
import {
  ListaEmpresas,
  ListaClientes,
  dadosParceiro,
  ListaContato,
} from "../../../../services/api";
import { Box } from "@chakra-ui/react";
import {
  BillingDataContainer,
  BillingDataContainerBilling,
  BillingDataContainerBillingContent,
  BillingDataContainerBillingContentCard,
  BillingDataContainerBillingContentCardContent,
  BillingDataContainerBillingContentCardContentBody,
  BillingDataContainerBillingContentCardContentBodyRow,
  BillingDataContainerBillingContentCardContentButton,
  BillingDataContainerBillingContentCardContentFooter,
  BillingDataContainerBillingContentCardHeader,
  BillingDataContainerBillingTab,
} from "./styles";

import {cpfMask,phoneMask} from '../../../../services/mask/index'
import ButtonRemove from "../../ComponentsPedidos/ButtonRemove";

class BillingData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_billing: this.props.data_request,
      all_billing: this.props.all_request,
      company_select: this.props.company_select,
      data_client: this.props.data_client,
      data_delivery: this.props.data_delivery,
      index_request: this.props.index_request,

      view_modal_company: false,
      view_modal_customer: false,
      view_modal_delivery: false,
      view_modal_contact: false
    };
  }

  componentDidMount() {
    console.log(this.props.company_select);
  }

  selectCompany = async (e) => {
    var data = JSON.parse(e.target.value);
    this.props.updateData(data, "company");
    this.setState({ company_select: data });
    this.setState({ view_modal_company: false });
  };

  selectCustomer = async (e) => {
    var dataSelect = JSON.parse(e.target.value);

    try {
      const response = await dadosParceiro.get(dataSelect.codigo_parceiro);
      var data = response.data;

      // var CEP_API = await fetch(`https://api.postmon.com.br/v1/cep/`+data.cep);
      var CEP_API = await fetch(`https://viacep.com.br/ws/${data.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var data_client = data;

      data_client.bairro = CEP_API_REST.bairro;
      data_client.municipio = CEP_API_REST.localidade;
      data_client.uf = CEP_API_REST.uf;
      data_client.logradouro = CEP_API_REST.logradouro;


      this.setState({ data_client: data_client });
      this.setState({ view_modal_customer: false });
      this.props.updateData(data_client, "customer");
      this.setState({ view_modal_contact: true });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectContact = async (e) => {
    var dataSelect = JSON.parse(e.target.value);

    try {

      this.state.data_client.nome_contato = dataSelect.nome_contato;
      this.state.data_client.numero_telefone = dataSelect.telefone_contato;
      this.state.data_client.numero_celular = dataSelect.celular_contato;
      this.state.data_client.codigo_contato = dataSelect.codigo_contato;
      this.state.data_client.email = dataSelect.email_contato;

      this.setState({update: true});
      this.setState({ view_modal_contact: false });
      this.props.updateData(this.state.data_client, "customer");
      
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectContactDelivery = async (e) => {
    var dataSelect = JSON.parse(e.target.value);

    try {

      this.state.data_delivery.nome_contato = dataSelect.nome_contato;
      this.state.data_delivery.numero_telefone = dataSelect.telefone_contato;
      this.state.data_delivery.numero_celular = dataSelect.celular_contato;
      this.state.data_delivery.codigo_contato = dataSelect.codigo_contato;
      this.state.data_delivery.email = dataSelect.email_contato;

      this.setState({update: true});
      this.setState({ view_modal_contact_delivery: false });
      this.props.updateData(this.state.data_delivery, "delivery");
      
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectDelivery = async (e) => {
    var dataSelect = JSON.parse(e.target.value);

    try {
      const response = await dadosParceiro.get(dataSelect.codigo_parceiro);
      var data = response.data;

      // var CEP_API = await fetch(`https://api.postmon.com.br/v1/cep/`+data.cep);
      var CEP_API = await fetch(`https://viacep.com.br/ws/${data.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var data_delivery = data;

      data_delivery.bairro = CEP_API_REST.bairro;
      data_delivery.municipio = CEP_API_REST.localidade;
      data_delivery.uf = CEP_API_REST.uf;
      data_delivery.logradouro = CEP_API_REST.logradouro;

      this.setState({ data_delivery: data_delivery });
      this.setState({ view_modal_delivery: false });
      this.props.updateData(data_delivery, "delivery");
      // this.setState({ view_modal_contact_delivery: true });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  render() {
    var {
      data_billing,
      all_billing,
      company_select,
      data_client,
      data_delivery,
    } = this.state;

    const returnDataCompany = [
      { title: "codigo_empresa", field:"codigo_empresa"},
      { title: "nome_empresa", field:"nome_empresa"},
      { title: "tipo_endereco", field:"tipo_endereco"},
      { title: "logradouro", field:"logradouro"},
      { title: "numero", field:"numero"},
      { title: "complemento", field:"complemento"},
      { title: "bairro", field:"bairro"},
      { title: "cidade", field:"cidade"},
      { title: "cep", field:"cep"},
      { title: "cpf_cnpj_parceiro", field:"cpf_cnpj_parceiro"},
    ];

    const gridCompany = [
      {
        title: "Nome",
        field: "nome_empresa",
        css: { width: "210px" },
        function: "",
      },

      { title: "Tipo endereço", field: "tipo_endereco", function: "" },

      { title: "Logradouro", field: "logradouro", function: "" },

      { title: "Numero", field: "numero", function: "" },

      { title: "Bairro", field: "bairro", function: "" },

      { title: "CEP", field: "cep", function: "" },

      { title: "Cidade", field: "cidade", function: "" },
    ];

    const returnDataCustomer = [
      { title: "bairro", field: "bairro" },
      {
        title: "cep",
        field: "cep",
      },
      {
        title: "codigo_contato",
        field: "codigo_contato",
      },
      {
        title: "codigo_parceiro",
        field: "codigo_parceiro",
      },
      {
        title: "complemento",
        field: "complemento",
      },
      {
        title: "cpf_cnpj_parceiro",
        field: "cpf_cnpj_parceiro",
      },
      {
        title: "email",
        field: "email",
      },
      {
        title: "inscricao_estadual",
        field: "inscricao_estadual",
      },
      {
        title: "logradouro",
        field: "logradouro",
      },
      {
        title: "municipio",
        field: "municipio",
      },
      {
        title: "nome_contato",
        field: "nome_contato",
      },
      {
        title: "numero",
        field: "numero",
      },
      {
        title: "numero_celular",
        field: "numero_celular",
      },
      {
        title: "numero_telefone",
        field: "numero_telefone",
      },
      {
        title: "razao_social_parceiro",
        field: "razao_social_parceiro",
      },
      {
        title: "uf",
        field: "uf",
      },
    ];

    const gridCustomer = [
      { title: "Nome", field: "nome_parceiro", function: "" },

      { title: "Razão social", field: "razao_social", function: "" },

      { title: "CPF / CNPJ", field: "cpf_cnpj", function: "" },

      { title: "Vendedor", field: "apelido", function: "" },
    ];
    return (
      <Box>
        <BillingDataContainer>
          <BillingDataContainerBilling>
            {all_billing.length > 0 ? (
              all_billing.map((data, idx) => {
                return (
                  <BillingDataContainerBillingTab>
                    <p>
                      FATURA | <h1>{idx + 1}</h1> CNPJ {data.cpf_cnpj_parceiro}{" "}
                      | {data.nome_parceiro} | {data.nome_contato} -{" "}
                      {data.email_contato}
                    </p>
                    <ButtonEdit
                      selectBilling={this.props.selectBilling}
                      idbilling={idx}
                    />
                    <ButtonRemove
                      deleteBilling={this.props.deleteBilling}
                      idbilling={idx}
                    />
                  </BillingDataContainerBillingTab>
                );
              })
            ) : (
              <></>
            )}
          </BillingDataContainerBilling>

          <TitleWithControl back={null}>
            <p>
              CONFIRME OU ALTERE OS <strong>DADOS DO FATURAMENTO</strong>
            </p>
            <h1>{this.state.index_request}</h1>
          </TitleWithControl>

          <BillingDataContainerBillingContent>
            {this.state.view_modal_company ? (
              <Modal
                closeModal={() => this.setState({ view_modal_company: false })}
                select={this.selectCompany}
                title_filter="sem filtro"
                call={{ endpoint: ListaEmpresas, method: "GET" }}
                config={{}}
                checkboxField={returnDataCompany}
                grid={gridCompany}
              />
            ) : (
              <></>
            )}

            {this.state.view_modal_customer ? (
              // <Modal
              //   closeModal={() => this.setState({ view_modal_customer: false })}
              //   select={this.selectCustomer}
              //   title_filter="PARCEIRO"
              //   call={{
              //     endpoint: ListaClientes,
              //     method: "POST",
              //     param: [{ field: "texto_buscado", find: "state" }],
              //   }}
              //   config={{}}
              //   checkboxField={returnDataCustomer}
              //   grid={gridCustomer}
              // />
              <ModalParceiro 
                  FecharModal={() => this.setState({ view_modal_customer: false })}
                  seleciona={this.selectCustomer}
                  title_filter={{
                    data: [
                      {
                        title: "Nome",
                        field: "nome_parceiro",
                      },
                      {
                        title: "CPFCNPJ",
                        field: "cpfcnpj_parceiro",
                      },
                      {
                        title: "CODPARC",
                        field: "codigo_parceiro",
                      },
                    ],
                  }}
                  call={{
                    endpoint: ListaClientes,
                    param: [
                      {
                        field: "nome_parceiro",
                        find: "state",
                      },
                      {
                        field: "cpfcnpj_parceiro",
                        find: "state",
                      },
                      {
                        field: "codigo_parceiro",
                        find: "state",
                      },
                    ],
                  }}
                  config={{}}
                  checkboxField={returnDataCustomer}
                  grid={gridCustomer}
              /> 
            ) : (
              <></>
            )}

            {this.state.view_modal_contact ? (
                <Modal
                  closeModal={() => this.setState({ view_modal_contact: false })}
                  select={this.selectContact}
                  title_filter="NOME DO CONTATO"
                  autosearch={true}
                  call={{
                    endpoint: ListaContato,
                    param: [
                      {
                        field: "codigo_parceiro",
                        find: "config",
                      },
                      {
                        field: "texto_buscado",
                        find: "state",
                      },
                    ],
                  }}
                  config={{
                    codigo_parceiro: this.state.data_client.codigo_parceiro,
                  }}
                  checkboxField={[
                    {
                      title: "codigo_contato",
                      field: "codigo_contato",
                    },
                    {
                      title: "nome_contato",
                      field: "nome_contato",
                    },
                    {
                      title: "email_contato",
                      field: "email_contato",
                    },
                    {
                      title: "telefone_contato",
                      field: "telefone_contato",
                    },
                    {
                      title: "celular_contato",
                      field: "celular_contato",
                    },
                  ]}
                  grid={[
                    {
                      title: "Nome",
                      field: "nome_contato",
                      function: "",
                    },

                    {
                      title: "Email",
                      field: "email_contato",
                      function: "",
                    },

                    {
                      title: "Telefone",
                      field: "telefone_contato",
                      function: "",
                    },

                    {
                      title: "Celular",
                      field: "celular_contato",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}
            {this.state.view_modal_contact_delivery ? (
                <Modal
                  closeModal={() => this.setState({ view_modal_contact_delivery: false })}
                  select={this.selectContactDelivery}
                  title_filter="NOME DO CONTATO"
                  autosearch={true}
                  call={{
                    endpoint: ListaContato,
                    param: [
                      {
                        field: "codigo_parceiro",
                        find: "config",
                      },
                      {
                        field: "texto_buscado",
                        find: "state",
                      },
                    ],
                  }}
                  config={{
                    codigo_parceiro: this.state.data_delivery.codigo_parceiro,
                  }}
                  checkboxField={[
                    {
                      title: "codigo_contato",
                      field: "codigo_contato",
                    },
                    {
                      title: "nome_contato",
                      field: "nome_contato",
                    },
                    {
                      title: "email_contato",
                      field: "email_contato",
                    },
                    {
                      title: "telefone_contato",
                      field: "telefone_contato",
                    },
                    {
                      title: "celular_contato",
                      field: "celular_contato",
                    },
                  ]}
                  grid={[
                    {
                      title: "Nome",
                      field: "nome_contato",
                      function: "",
                    },

                    {
                      title: "Email",
                      field: "email_contato",
                      function: "",
                    },

                    {
                      title: "Telefone",
                      field: "telefone_contato",
                      function: "",
                    },

                    {
                      title: "Celular",
                      field: "celular_contato",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}

            {this.state.view_modal_delivery ? (
              // <Modal
              //   closeModal={() => this.setState({ view_modal_delivery: false })}
              //   select={this.selectDelivery}
              //   title_filter="PARCEIRO"
              //   call={{
              //     endpoint: ListaClientes,
              //     method: "POST",
              //     param: [{ field: "texto_buscado", find: "state" }],
              //   }}
              //   config={{}}
              //   checkboxField={returnDataCustomer}
              //   grid={gridCustomer}
              // />
              <ModalParceiro 
                  FecharModal={() => this.setState({ view_modal_delivery: false })}
                  seleciona={this.selectDelivery}
                  title_filter={{
                    data: [
                      {
                        title: "Nome",
                        field: "nome_parceiro",
                      },
                      {
                        title: "CPFCNPJ",
                        field: "cpfcnpj_parceiro",
                      },
                      {
                        title: "CODPARC",
                        field: "codigo_parceiro",
                      },
                    ],
                  }}
                  call={{
                    endpoint: ListaClientes,
                    param: [
                      {
                        field: "nome_parceiro",
                        find: "state",
                      },
                      {
                        field: "cpfcnpj_parceiro",
                        find: "state",
                      },
                      {
                        field: "codigo_parceiro",
                        find: "state",
                      },
                    ],
                  }}
                  config={{}}
                  checkboxField={returnDataCustomer}
                  grid={gridCustomer}
              />
            ) : (
              <></>
            )}

            {this.state.index_request == 1 ? (
              <BillingDataContainerBillingContentCard>
                <BillingDataContainerBillingContentCardHeader>
                  <p>EMPRESA:</p>
                </BillingDataContainerBillingContentCardHeader>
                <BillingDataContainerBillingContentCardContent>
                  <BillingDataContainerBillingContentCardContentBody>
                    <BillingDataContainerBillingContentCardContentBodyRow>
                      <p>
                        <strong>Razão social: </strong>
                        {company_select.nome_empresa}
                      </p>
                    </BillingDataContainerBillingContentCardContentBodyRow>
                    <BillingDataContainerBillingContentCardContentBodyRow>
                      <p>
                        <strong>CNPJ:</strong>
                        {cpfMask(company_select.cpf_cnpj_parceiro)}
                      </p>
                    </BillingDataContainerBillingContentCardContentBodyRow>
                    <BillingDataContainerBillingContentCardContentBodyRow>
                      <p>
                        <strong>Endereço: </strong>
                        {company_select.tipo_endereco}{" "}
                        {company_select.logradouro}, {company_select.numero}{" "}
                        {company_select.complemento} - {company_select.bairro}{" "}
                      </p>
                    </BillingDataContainerBillingContentCardContentBodyRow>
                    <BillingDataContainerBillingContentCardContentBodyRow>
                      <p>
                        <strong>Cidade: </strong>
                        {company_select.cidade}
                      </p>
                    </BillingDataContainerBillingContentCardContentBodyRow>
                    <BillingDataContainerBillingContentCardContentBodyRow>
                      <p>
                        <strong>CEP:</strong> {company_select.cep}
                      </p>
                    </BillingDataContainerBillingContentCardContentBodyRow>
                  </BillingDataContainerBillingContentCardContentBody>
                  <BillingDataContainerBillingContentCardContentFooter>
                    <BillingDataContainerBillingContentCardContentButton
                      onClick={() =>
                        this.setState({
                          view_modal_company: !this.state.view_modal_company,
                        })
                      }
                    >
                      <span className="icon icon-25 icon-edit-green"></span>
                      <p>Editar</p>
                    </BillingDataContainerBillingContentCardContentButton>
                  </BillingDataContainerBillingContentCardContentFooter>
                </BillingDataContainerBillingContentCardContent>
              </BillingDataContainerBillingContentCard>
            ) : (
              <></>
            )}

            <BillingDataContainerBillingContentCard>
              <BillingDataContainerBillingContentCardHeader>
                <p>DADOS DO FATURAMENTO:</p>
              </BillingDataContainerBillingContentCardHeader>

              <BillingDataContainerBillingContentCardContent>
                <BillingDataContainerBillingContentCardContentBody>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Razão social: </strong>
                      {data_client.razao_social_parceiro.length > 20
                        ? '(Cód.: '+data_client.codigo_parceiro+') '+data_client.razao_social_parceiro.substr(0, 18) +
                          "..."
                        : '(Cód.: '+data_client.codigo_parceiro+') '+data_client.razao_social_parceiro}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Endereço: </strong>
                      {data_client.logradouro}, {data_client.numero} -{" "}
                      {data_client.bairro}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Nome: </strong>
                      {data_client.nome_contato.length > 17
                        ? data_client.nome_contato.substr(0, 17) + "..."
                        : data_client.nome_contato}
                    </p>
                    <p>
                      <strong>Tel: </strong>
                      {phoneMask(data_client.numero_telefone)}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Email: </strong> {data_client.email}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Cidade/UF: </strong> {data_client.municipio}/
                      {data_client.uf}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>CEP: </strong> {data_client.cep}
                    </p>
                    <p>
                      <strong>CNPJ: </strong> {cpfMask(data_client.cpf_cnpj_parceiro)}
                    </p>
                    <p>
                      <strong>IE: </strong> Isento
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                </BillingDataContainerBillingContentCardContentBody>
                <BillingDataContainerBillingContentCardContentFooter>
                  <BillingDataContainerBillingContentCardContentButton
                    onClick={() =>
                      this.setState({
                        view_modal_customer: !this.state.view_modal_customer,
                      })
                    }
                  >
                    <span className="icon icon-25 icon-edit-green"></span>
                    <p>Editar</p>
                  </BillingDataContainerBillingContentCardContentButton>
                </BillingDataContainerBillingContentCardContentFooter>
              </BillingDataContainerBillingContentCardContent>
            </BillingDataContainerBillingContentCard>
            <BillingDataContainerBillingContentCard>
              <BillingDataContainerBillingContentCardHeader>
                <p>DADOS DA ENTREGA:</p>
              </BillingDataContainerBillingContentCardHeader>
              <BillingDataContainerBillingContentCardContent>
                <BillingDataContainerBillingContentCardContentBody>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Razão social: </strong>
                      {data_delivery.razao_social_parceiro.length > 20
                        ? '(Cód.: '+data_delivery.codigo_parceiro+') '+data_delivery.razao_social_parceiro.substr(0, 18) +
                          "..."
                        : '(Cód.: '+data_delivery.codigo_parceiro+') '+data_delivery.razao_social_parceiro}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Endereço: </strong>
                      {data_delivery.logradouro}, {data_delivery.numero} -{" "}
                      {data_delivery.bairro}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  {/* <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Nome: </strong>
                      {data_delivery.nome_contato.length > 17
                        ? data_delivery.nome_contato.substr(0, 17) + "..."
                        : data_delivery.nome_contato}
                    </p>
                    <p>
                      <strong>Tel: </strong>
                      {phoneMask(data_delivery.numero_telefone)}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Email: </strong> {data_delivery.email}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow> */}
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>Cidade/UF: </strong> {data_delivery.municipio}/
                      {data_delivery.uf}
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                  <BillingDataContainerBillingContentCardContentBodyRow>
                    <p>
                      <strong>CEP: </strong> {data_delivery.cep}
                    </p>
                    <p>
                      <strong>CNPJ: </strong> {cpfMask(data_delivery.cpf_cnpj_parceiro)}
                    </p>
                    <p>
                      <strong>IE: </strong> Isento
                    </p>
                  </BillingDataContainerBillingContentCardContentBodyRow>
                </BillingDataContainerBillingContentCardContentBody>
                <BillingDataContainerBillingContentCardContentFooter>
                  <BillingDataContainerBillingContentCardContentButton
                    onClick={() =>
                      this.setState({
                        view_modal_delivery: !this.state.view_modal_delivery,
                      })
                    }
                  >
                    <span className="icon icon-25 icon-edit-green"></span>
                    <p>Editar</p>
                  </BillingDataContainerBillingContentCardContentButton>
                </BillingDataContainerBillingContentCardContentFooter>
              </BillingDataContainerBillingContentCardContent>
            </BillingDataContainerBillingContentCard>
          </BillingDataContainerBillingContent>

          <ButtonContinue onClick={this.props.continue} />
        </BillingDataContainer>
      </Box>
    );
  }
}

export default BillingData;
